import React, { Component } from 'react';
import { Router, Route, hashHistory, IndexRedirect, IndexRoute } from 'react-router';
import { checkLogin } from '../utils/hook';
import { CURRENT_USER_INFO } from '../constants/common';
import { getLocal } from '../utils/storage';
import { canAccess } from '../utils/permission';
import { goAnchor } from '../components/financialPicture/common/commons';
import Frame from '../layouts/frame/Frame';
import NotFound from '../components/common/error/notFound/NotFound';
import SystemError from '../components/common/error/systemError/SystemError';
import Login from '../components/login/Login'; // 登录
import ForgotPassword from '../components/forgotPassword/ForgotPassword'; // 忘记密码
import Index from '../components/financialPicture/index/Index'; // 首页
import PictureFrame from '../components/financialPicture/common/frame/Frame'; // 财务画像-布局
import Overview from '../components/financialPicture/overview/Overview'; // 财务画像-概述
import BaseInfo from '../components/financialPicture/baseInfo/BaseInfo'; // 财务画像-基础信息
import HistoryPunishment from '../components/financialPicture/historyPunishment/HistoryPunishment'; // 财务画像-历史处罚
import FinancialRiskAnalysis from '../components/financialPicture/financialRiskAnalysis/FinancialRiskAnalysis'; // 财务画像-财务风险分析
import FinancialFraudAnalysis from '../components/financialPicture/financialFraudAnalysis/FinancialFraudAnalysis'; // 财务画像-财务造假分析
import RegulatoryStatistical from '../components/regulatoryStatistical/Index'; // 监管统计
import Personal from '../components/personal/Index'; // 个人中心基本结构
import Log from '../components/personal/log/Index'; // 历史报告
import Report from '../components/personal/report/Index'; // 历史报告
import Collect from '../components/personal/collect/Index'; // 我的收藏
import Pwd from '../components/personal/pwd/Index'; // 密码修改
import Admin from '../components/admin/Index'; // 管理员界面

export default class Root extends Component {
    /**
     * 路由改变时，回到顶部(当需要锚点定位时，去url里的参数：anchorId 为对应dom的id值)
     */
    goTop = () => {
        const { anchorId } = hashHistory.getCurrentLocation().query;
        if (anchorId) {
            goAnchor(anchorId);
        } else {
            window.scrollTo(0, 0); // 返回顶部
        }
    };

    onEnter(nextState, replace) {
        let isLogin = getLocal(CURRENT_USER_INFO); // 是否登录

        if (!isLogin && !this.white) { // 没有登录, 并且不是免登陆页面，跳转登录页
            return replace(`/login?callback=${encodeURIComponent(location.href)}`);
        }
        if (!canAccess(this)) { // 没有权限
            replace('/notFound');
        }
    }

    render() {
        return (
            <Router history={hashHistory}>
                {/* 添加onEnter={checkLogin}属性, 可进行登录校验 */}
                {/* 登录页 */}
                <Route path="/login" component={Login} />
                {/* 忘记密码页 */}
                <Route path="/wjmm" component={ForgotPassword} />

                <Route path="/" component={Frame} onEnter={checkLogin} onChange={this.goTop}>
                    <IndexRedirect to="/jgtj" />
                    {/* 监管统计 */}
                    <Route path="/jgtj" component={RegulatoryStatistical} />
                    {/* 财务画像 */}
                    <Route path="/cwhx">
                        <IndexRoute component={Index}/> {/* 财务画像-首页（搜索页） */}
                        <Route path="sy" component={PictureFrame}>
                            <IndexRedirect to="gs" />
                            <Route path="gs" component={Overview} /> {/* 财务画像-概述 */}
                            <Route path="jbxx" component={BaseInfo} /> {/* 财务画像-基础本信息 */}
                            <Route path="lscf" component={HistoryPunishment} /> {/* 财务画像-历史处罚 */}
                            <Route path="cwzjfx" component={FinancialFraudAnalysis} /> {/* 财务画像-财务造假分析 */}
                            <Route path="cwfxfx" component={FinancialRiskAnalysis} /> {/* 财务画像-财务风险分析 */}
                        </Route>
                    </Route>
                    {/* 个人中心 */}
                    <Route path="grzx" component={Personal}>
                        <IndexRedirect to="log" />
                        <Route path="log" component={Log} />
                        <Route path="report" component={Report} />
                        <Route path="collect" component={Collect} />
                        <Route path="pwd" component={Pwd} />
                    </Route>
                    {/* 管理员界面 */}
                    <Route path="admin" uType="1" onEnter={this.onEnter} component={Admin} />
                </Route>
                {/* 404 or error */}
                <Route path="/systemError" component={SystemError} />
                <Route path="*" component={NotFound} />
            </Router>
        );
    }
}



// WEBPACK FOOTER //
// ./src/routes/Root.jsx